import { Component } from '@theme/component';

/** @typedef {{ enquiry?: HTMLDetailsElement, formStatus?: HTMLElement }} ProfileRefs */
/** Enquiry anchors remain usable without JavaScript; enhancement opens the native disclosure.
 * @extends {Component<ProfileRefs>}
 */
class BroxCoachProfile extends Component {
  connectedCallback() { super.connectedCallback(); this.#restoreResponse(); }
  updatedCallback() { super.updatedCallback(); this.#restoreResponse(); }

  #restoreResponse() {
    if (this.refs.formStatus && this.refs.enquiry) this.refs.enquiry.open = true;
  }

  /** @param {MouseEvent} event - Native enquiry link activation. */
  handleEnquiry(event) {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('a');
    if (!(link instanceof HTMLAnchorElement) || !this.contains(link) || !this.refs.enquiry) return;
    this.refs.enquiry.open = true;
    // Leave native fragment navigation and history intact.
  }

  /** @param {Event} _event - Shared field events; native constraints own validation. */
  handleInput(_event) {}
}
if (!customElements.get('brox-coach-profile')) customElements.define('brox-coach-profile', BroxCoachProfile);
